export const POST_INICIAR_SESION = 'post_iniciar_sesion';
export const POST_CERRAR_SESION = 'post_cerrar_sesion';
export const POST_REFRESCAR_TOKEN = 'post_refrescar_token';
export const POST_ENVIAR_CODIGO = 'post_enviar_codigo_verificacion'